<template>
  <transition name="fade">
    <div v-show="show" class="up-action" :id="id">
      <div class="mask" v-if="mask"></div>
      <slot></slot>
    </div>
  </transition>
</template>

<script>
export default {
  name: 'upAction',
  data () {
    return {};
  },
  props: {
    show: {
      type: Boolean,
      default: false
    },
    id: {
      type: String,
      default: function () {
        return parseInt(Math.random() * 1000000).toString()
      }
    },
    mask: {
      type: Boolean,
      default: true
    },
    clickClose: {
      type: Boolean,
      default: true
    }
  },
  mounted () {
    if (this.clickClose) {
      let _that = this
      document.getElementById(_that.id).addEventListener('click', function (event) {
        if (event.target.className === 'mask') {
          _that.$emit('update:show', false)
        }
      }, true)
    }
  },
  methods: {
  }
};
</script>

<style scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}

.mask {
  background: #000000;
  opacity: 0.8;
  height: 100%;
  width: 100%;
  position: absolute;
  top: 0;
  left: 0;
}

.up-action {
  height: 100vh;
  width: 100vw;
  /* background-color: black; */
  position: absolute;
  top: 0;
  left: 0;
  z-index: 999;
}
</style>
